export function DecorativeBackground() {
  return (
    <>
      {/* Animated background gradient */}
      <div className="absolute inset-0 opacity-15 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-orange-400/5" />
      </div>

      {/* Static decorative elements */}
      <div className="fixed inset-0 pointer-events-none z-0 opacity-15">
        <div className="absolute top-1/6 left-1/5 w-1 h-1 bg-orange-400/25 rounded-full animate-pulse" />
        <div
          className="absolute top-2/3 right-1/4 w-2 h-2 bg-orange-400/20 rounded-full animate-pulse"
          style={{ animationDelay: "1s" }}
        />
        <div
          className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-orange-400/30 rounded-full animate-pulse"
          style={{ animationDelay: "2s" }}
        />
        <div
          className="absolute top-1/3 right-1/6 w-1 h-1 bg-orange-400/25 rounded-full animate-pulse"
          style={{ animationDelay: "0.5s" }}
        />
        <div
          className="absolute bottom-1/2 left-2/3 w-1 h-1 bg-orange-400/20 rounded-full animate-pulse"
          style={{ animationDelay: "1.5s" }}
        />
        <div
          className="absolute top-3/4 left-1/2 w-2 h-2 bg-orange-400/15 rounded-full animate-pulse"
          style={{ animationDelay: "3s" }}
        />
        <div
          className="absolute bottom-1/6 right-1/2 w-1 h-1 bg-orange-400/30 rounded-full animate-pulse"
          style={{ animationDelay: "2.5s" }}
        />
        <div
          className="absolute top-1/2 left-1/6 w-1.5 h-1.5 bg-orange-400/25 rounded-full animate-pulse"
          style={{ animationDelay: "4s" }}
        />
      </div>

      {/* Edge glow effects and side gradients */}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent"></div>
        <div className="absolute top-0 bottom-0 left-0 w-px bg-gradient-to-b from-transparent via-orange-500/30 to-transparent"></div>
        <div className="absolute top-0 bottom-0 right-0 w-px bg-gradient-to-b from-transparent via-orange-500/30 to-transparent"></div>

        {/* Enhanced side gradient overlays */}
        <div className="absolute top-0 bottom-0 left-0 w-48 bg-gradient-to-r from-[#1c202e]/30 via-[#23263a]/20 to-transparent"></div>
        <div className="absolute top-0 bottom-0 right-0 w-48 bg-gradient-to-l from-[#1c202e]/30 via-[#23263a]/20 to-transparent"></div>

        {/* Vertical accent lines */}
        <div className="absolute top-0 bottom-0 left-24 w-px bg-gradient-to-b from-transparent via-orange-500/20 to-transparent"></div>
        <div className="absolute top-0 bottom-0 right-24 w-px bg-gradient-to-b from-transparent via-orange-500/20 to-transparent"></div>

        {/* Subtle circular gradients for depth */}
        <div
          className="absolute top-1/3 left-12 w-40 h-40 rounded-full blur-2xl opacity-15"
          style={{
            background: "radial-gradient(circle, rgba(249, 115, 22, 0.15) 0%, transparent 70%)",
          }}
        ></div>
        <div
          className="absolute bottom-1/3 right-12 w-40 h-40 rounded-full blur-2xl opacity-15"
          style={{
            background: "radial-gradient(circle, rgba(249, 115, 22, 0.15) 0%, transparent 70%)",
          }}
        ></div>

        {/* Additional depth elements */}
        <div className="absolute top-1/2 left-4 w-16 h-32 bg-gradient-to-b from-orange-500/5 to-transparent rounded-full blur-xl"></div>
        <div className="absolute top-1/2 right-4 w-16 h-32 bg-gradient-to-b from-orange-500/5 to-transparent rounded-full blur-xl"></div>
      </div>
    </>
  );
}
